// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* InlineEdit — inline-editable input for table preview cells */

.inline-edit {
  background: transparent;
  border: 0;
  border-bottom: 1px dashed var(--border);
  padding: 2px 4px;
  font-family: inherit;
  font-size: inherit;
  color: var(--text);
  width: 100%;
  min-width: 60px;
  transition:
    border-color 100ms ease,
    background 100ms ease;
}

.inline-edit:focus,
.inline-edit:hover {
  background: var(--signal-soft);
  border-bottom: 1px solid var(--signal);
  outline: none;
}

.inline-edit::placeholder {
  color: var(--text-muted);
  font-style: italic;
}

/* Warn-fix: auto-corrected cell */
.inline-edit--warn-fix {
  border-bottom: 1px solid var(--warn);
  background: rgba(180, 83, 9, 0.06);
}

.inline-edit--warn-fix:focus,
.inline-edit--warn-fix:hover {
  background: rgba(180, 83, 9, 0.1);
  border-bottom: 1px solid var(--warn);
}

/* Error: required field missing or invalid */
.inline-edit--error {
  border-bottom: 1px solid var(--danger);
}

.inline-edit--error::placeholder {
  color: var(--danger);
  opacity: 0.7;
}

/* Cell markers: "expandido", "corregido", "requerido" */
.cell-marker {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-left: 6px;
  white-space: nowrap;
  vertical-align: middle;
}

.cell-marker--warn {
  color: var(--warn);
}

.cell-marker--error {
  color: var(--danger);
}

/* Cell wrapper for input + optional marker */
.inline-edit-cell {
  display: flex;
  align-items: center;
  gap: 0;
}

/* Dark mode */
[data-theme='dark'] .inline-edit {
  color: var(--ink-text);
  border-bottom-color: var(--ink-rule);
}

[data-theme='dark'] .inline-edit:focus,
[data-theme='dark'] .inline-edit:hover {
  background: rgba(12, 107, 240, 0.16);
  border-bottom-color: var(--signal);
}

[data-theme='dark'] .inline-edit--warn-fix {
  background: rgba(180, 83, 9, 0.16);
  border-bottom-color: var(--warn);
}

[data-theme='dark'] .inline-edit--warn-fix:focus,
[data-theme='dark'] .inline-edit--warn-fix:hover {
  background: rgba(180, 83, 9, 0.22);
}

[data-theme='dark'] .cell-marker--warn {
  color: #f2b870;
}

[data-theme='dark'] .cell-marker--error {
  color: #f2887e;
}
`, "",{"version":3,"sources":["webpack://./src/ui/InlineEdit/InlineEdit.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,uBAAuB;EACvB,SAAS;EACT,uCAAuC;EACvC,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf;;yBAEuB;AACzB;;AAEA;;EAEE,8BAA8B;EAC9B,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;;EAEE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA,6CAA6C;AAC7C;EACE,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;AACR;;AAEA,cAAc;AACd;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* InlineEdit — inline-editable input for table preview cells */\n\n.inline-edit {\n  background: transparent;\n  border: 0;\n  border-bottom: 1px dashed var(--border);\n  padding: 2px 4px;\n  font-family: inherit;\n  font-size: inherit;\n  color: var(--text);\n  width: 100%;\n  min-width: 60px;\n  transition:\n    border-color 100ms ease,\n    background 100ms ease;\n}\n\n.inline-edit:focus,\n.inline-edit:hover {\n  background: var(--signal-soft);\n  border-bottom: 1px solid var(--signal);\n  outline: none;\n}\n\n.inline-edit::placeholder {\n  color: var(--text-muted);\n  font-style: italic;\n}\n\n/* Warn-fix: auto-corrected cell */\n.inline-edit--warn-fix {\n  border-bottom: 1px solid var(--warn);\n  background: rgba(180, 83, 9, 0.06);\n}\n\n.inline-edit--warn-fix:focus,\n.inline-edit--warn-fix:hover {\n  background: rgba(180, 83, 9, 0.1);\n  border-bottom: 1px solid var(--warn);\n}\n\n/* Error: required field missing or invalid */\n.inline-edit--error {\n  border-bottom: 1px solid var(--danger);\n}\n\n.inline-edit--error::placeholder {\n  color: var(--danger);\n  opacity: 0.7;\n}\n\n/* Cell markers: \"expandido\", \"corregido\", \"requerido\" */\n.cell-marker {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  margin-left: 6px;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.cell-marker--warn {\n  color: var(--warn);\n}\n\n.cell-marker--error {\n  color: var(--danger);\n}\n\n/* Cell wrapper for input + optional marker */\n.inline-edit-cell {\n  display: flex;\n  align-items: center;\n  gap: 0;\n}\n\n/* Dark mode */\n[data-theme='dark'] .inline-edit {\n  color: var(--ink-text);\n  border-bottom-color: var(--ink-rule);\n}\n\n[data-theme='dark'] .inline-edit:focus,\n[data-theme='dark'] .inline-edit:hover {\n  background: rgba(12, 107, 240, 0.16);\n  border-bottom-color: var(--signal);\n}\n\n[data-theme='dark'] .inline-edit--warn-fix {\n  background: rgba(180, 83, 9, 0.16);\n  border-bottom-color: var(--warn);\n}\n\n[data-theme='dark'] .inline-edit--warn-fix:focus,\n[data-theme='dark'] .inline-edit--warn-fix:hover {\n  background: rgba(180, 83, 9, 0.22);\n}\n\n[data-theme='dark'] .cell-marker--warn {\n  color: #f2b870;\n}\n\n[data-theme='dark'] .cell-marker--error {\n  color: #f2887e;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
